import API from '@/api/Project'
import { path, mergeDeepRight } from 'ramda'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Project')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  addon(state, payload) {
    if (!state.item.id) return
    if (payload.state) state.item.metadata.addons.push(payload.addon)
    else state.item.metadata.addons.splice(state.item.metadata.addon.indexOf(payload.addon), 1)
  },
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
  updateSchema({ commit, state }) {
    if (!state.item.id) return
    return API.get({ id: state.item.id }, { query: 'ProjectSchemaUpdate' }).then(data => {
      commit('set', mergeDeepRight(state.item, data))
    })
  },
  addon({ commit, state }, payload) {
    if (!payload.project && !state.item.id) return
    return API.addon({ project: state.item.id, ...payload }).then(() => {
      commit('addon', payload)
    })
  },
}

const getters = {
  hasRole: state => (role, context) => {
    if (!context) context = state.item
    role = role instanceof Array ? role : [role]
    if (!path(['access', 'roles', 'length'], context)) return false
    return role.some(r => {
      if (r instanceof RegExp) return context.access.roles.some(ro => ro.match(r))
      return context.access.roles.includes(r)
    })
  },
  getDisabledField: state => (field, context) => {
    if (!context) context = state.item
    const disabledFields = path(['metadata', 'disabledFields'], context)

    if (!disabledFields) return

    if ('project' in disabledFields && !field.startsWith('project.')) return disabledFields.project[field]

    const type = ['project', 'unit', 'post'].find(t => field.startsWith(`${t}.`))
    if (type) return disabledFields[type][field.replace(new RegExp(`^${type}\.`), '')]

    return disabledFields[field]
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
